var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2848 13.2341C10.9033 13.1222 11.5519 13.0609 12.2203 13.0609C12.8889 13.061 13.5386 13.1224 14.1572 13.2343C17.4837 13.8364 19.9411 15.9002 19.9411 17.7486C19.9411 19.9409 16.4842 21 12.2203 21C7.95651 21 4.5 19.9409 4.5 17.7486C4.5 15.8999 6.95773 13.8358 10.2848 13.2341ZM10.497 11.1777C11.024 11.4107 11.6071 11.5401 12.2203 11.5402C12.8338 11.5402 13.418 11.4109 13.9453 11.178C15.4449 10.5154 16.4915 9.01499 16.4915 7.27012C16.4915 4.9118 14.5797 3 12.2214 3C9.86304 3 7.95124 4.9118 7.95124 7.27012C7.95124 9.01481 8.99759 10.5151 10.497 11.1777Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilled);
export default __webpack_public_path__ + "static/media/user-filled.7fa4b25e9bcbb285fb3ee2daba69aadd.svg";
export { ForwardRef as ReactComponent };